import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './modules/core/components/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './modules/core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';
import { SharedModule } from './modules/shared/shared.module';
import { AssesmentComponent } from '@app-modules/feature/products/assesment/assesment.component';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { MathModule } from '@app-shared/directives/math/math.module';
import { NgxSpinnerModule } from "ngx-spinner";
import { NeetComponent } from '@app-modules/feature/products/neet/neet.component';
import { JeeComponent } from '@app-modules/feature/products/jee/jee.component';
import { AboutComponent } from '@app-modules/feature/products/about/about.component';

import { ClassService } from './core/services/class.service';
import { HttpClientModule } from '@angular/common/http';
import { TestSeriesComponent } from '@app-modules/feature/products/test-series/test-series.component';
import { NeetLandingComponent } from '@app-modules/feature/products/neet-landing/neet-landing.component';
import { SpecialSeriesComponent } from '@app-modules/feature/products/special-series/special-series.component';
import { ThankYouComponent } from '@app-modules/feature/products/thankyou/thankyou.component';
import { JeeLiveclassComponent } from '@app-modules/feature/products/jee-liveclass/jee-liveclass.component';
import { IliteComponent } from '@app-modules/feature/products/ilite/ilite.component';
import { PaynowregistrationComponent } from '@app-modules/feature/products/paynowregistration/paynowregistration.component';
import { CongrajulationsComponent } from '@app-modules/feature/products/congrajulations/congrajulations.component';
import { RepeaterComponent } from '@app-modules/feature/products/repeater/repeater.component';
import { IliteModalComponent } from '@app-modules/feature/products/ilite/modal/content.component';
//import { initializeApp } from 'firebase/app';
import { ToastrModule } from 'ngx-toastr';
import { CartActionComponent } from './modules/feature/subscription/cart-action/cart-action.component';

import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from 'src/environments/environment';
//import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFirestoreModule } from '@angular/fire/firestore';

import firebase from "firebase/app";
import "firebase/remote-config";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SelfLearnV2Module } from 'projects/selflearnv2-ui/src/app/modules/feature/self-learn-v2/self-learn-v2.module'
import { GoalSettingModule } from 'projects/goal-setting-ui/src/app/modules/goal-setting/goal-setting.module';
//import { getAnalytics } from 'firebase/analytics/';

const firebaseConfig = {


  // apiKey: "AIzaSyBOvjfYqrlsYHALU936NXq7MZjXDDudl2c",
  // authDomain: "doubts-aa0c1.firebaseapp.com",
  // databaseURL: "https://doubts-aa0c1-default-rtdb.firebaseio.com",
  // projectId: "doubts-aa0c1",
  // storageBucket: "doubts-aa0c1.appspot.com",
  // messagingSenderId: "339511367616",
  // appId: "1:339511367616:web:6f17eae5ca85b21026da25",
  // measurementId: "G-TYE54HH585"


  "apiKey": "AIzaSyAKIzu_pegviRDYGhVR7xqX9F2pY4N0M14",
  "authDomain": "unified-infinity-learn.firebaseapp.com",
  "projectId": "unified-infinity-learn",
  "storageBucket": "unified-infinity-learn.appspot.com",
  "messagingSenderId": "668051385949",
  "appId": "1:668051385949:web:820adef20962928ddfe7b4",
  "measurementId": "G-NVQRR77Z5K"


	};

//const app = initializeApp(firebaseConfig);

const app =  firebase.initializeApp(firebaseConfig);
const remoteConfig = firebase.remoteConfig();

export const analytics = firebase.analytics();
//export const analytics = getAnalytics(app);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AssesmentComponent,
    NeetComponent,
    JeeComponent,
    AboutComponent,
    TestSeriesComponent,
    NeetLandingComponent,
    SpecialSeriesComponent,
    AppComponent,
    ThankYouComponent,
    JeeLiveclassComponent,
    IliteComponent,
    IliteModalComponent,
    PaynowregistrationComponent,
    CongrajulationsComponent,
    RepeaterComponent,
    CartActionComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    NgOtpInputModule,
    NgxWebstorageModule.forRoot(),
    MathModule,
    NgxSpinnerModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule.forRoot({
      timeOut: 1500,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      enableHtml:true,
    }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    NgbModule,
    SelfLearnV2Module,
    GoalSettingModule
  ],

  providers: [ClassService],
  bootstrap: [AppComponent]
})
export class AppModule { }
